<div class="container-fluid pb-5 adjusted-height">
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <legend data-automation="microsoft-365-licenses-header-legend">
      {{ 'tkey;selfserve.microsoft365.title' | translate }}
    </legend>
    <div class="row h-100">
      <div class="col-md-7 order-2 order-md-1 h-100 overflow-auto">
        @if (licenseConfig().usageLocation.show) {
          <br />
        }
        <ziro-select [fieldId]="'usageLocation'"></ziro-select>
        <br />
        <ziro-multi-checkbox #licensesCheckboxes [fieldId]="'licenses'"></ziro-multi-checkbox>
      </div>
      <div class="col-md-5 order-1 order-md-2 microsoft-365-logo">
        <i [ngClass]="icons.MICROSOFT_365_SMALL"></i>
      </div>
    </div>
  </ziro-collapsible-section-card>
</div>
